<div>

    <form [formGroup]="flashcardStructureForm" (submit)="saveStructure()">

        <ul class="grid-cols-1 grid gap-3">

            @if (flashcardStructureForm.contains('number_series')) {
            <li>
                <div class="collapse collapse-plus bg-white border overflow-x-auto">
                    <input type="checkbox" />
                    <div class="collapse-title flex items-center font-medium">Number Series</div>

                    <div class="collapse-content border-t" formGroupName="number_series">
                        <div class="pt-2">

                            <div class="overflow-x-auto">
                                <table class="table w-[30rem] ">
                                    <!-- head -->
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th>From</th>
                                            <th>To</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody formArrayName="data">

                                        @for (i of numberSeriesArray.controls; track $index) {
                                        <tr formGroupName="{{$index}}">
                                            <th>{{1+$index}}</th>
                                            <td><input type="number" min="0" class="input input-ghost w-full input-sm"
                                                    formControlName="from"></td>
                                            <td><input type="number" min="0" class="input input-ghost w-full input-sm"
                                                    formControlName="to"></td>
                                            <td>
                                                @if ($index == 0) {
                                                <button type="button" (click)="modifyNumberSeries('add')" class="btn btn-sm btn-square"><i
                                                        class="ri-add-line"></i></button>
                                                }@else{

                                                <button type="button" (click)="modifyNumberSeries('remove', $index)" class="btn btn-sm btn-square bg-red-100 text-red-600"><i
                                                        class="ri-delete-bin-7-line"></i></button>
                                                }
                                            </td>
                                        </tr>
                                        }

                                    </tbody>
                                </table>
                            </div>



                        </div>
                    </div>

                </div>
            </li>
            }

            <li>
                <div class="collapse collapse-plus bg-white border">
                    <input type="checkbox" />
                    <div class="collapse-title flex items-center font-medium">Alphabets</div>

                    @if ((flashcardStructureForm.get('alphabets')?.get('data')?.value?.length || 0) > 0) {
                    <div class="px-3 pb-3 flex gap-2 flex-wrap">
                        @for (i of flashcardStructureForm.get('alphabets')?.get('data')?.value; track $index) {
                        <button (click)="removeStructureSelection('alphabets',i.id)" type="button"
                            class="btn btn-xs font-medium flex items-center gap-2"><span>{{i.value}}</span> <i
                                class="ri-close-line"></i></button>
                        }
                    </div>
                    }


                    <div class="collapse-content border-t">
                        <div class="pt-2">
                            @if (structure?.alphabets) {
                            <ul class="grid grid-cols-4 gap-2">
                                @for (i of structure?.alphabets; track $index) {
                                <li class="flex items-center gap-2">
                                    <input (change)="updateStructureSelection($event,'alphabets',i)" type="checkbox"
                                        id="alphabets_{{$index}}" class="checkbox checkbox-sm"
                                        [checked]="isOptionSelected('alphabets', i.id)" />
                                    <label class="label" for="alphabets_{{$index}}">
                                        <span class="label-text">{{i.value}} </span>
                                    </label>
                                </li>
                                }
                            </ul>
                            }

                        </div>
                    </div>
                </div>
            </li>


            <li>
                <div class="collapse collapse-plus bg-white border">
                    <input type="checkbox" />

                    <div class="collapse-title flex items-center font-medium">Root Words</div>

                    @if ((flashcardStructureForm.get('root_words')?.get('data')?.value?.length || 0) > 0) {
                    <div class="px-3 pb-3 flex gap-2 flex-wrap">
                        @for (i of flashcardStructureForm.get('root_words')?.get('data')?.value; track $index) {
                        <button (click)="removeStructureSelection('root_words',i.id)" type="button"
                            class="btn btn-xs font-medium flex items-center gap-2"><span>{{i.value}}</span> <i
                                class="ri-close-line"></i></button>
                        }
                    </div>
                    }

                    <div class="collapse-content border-t">
                        <div class="pt-2 max-h-[20rem] overflow-y-auto">

                            @if (structure?.root_words) {
                            <ul class="grid grid-cols-4 gap-2">
                                @for (i of structure?.root_words; track $index) {
                                <li class="flex items-center gap-2">
                                    <input (change)="updateStructureSelection($event,'root_words',i)" type="checkbox"
                                        id="root_words_{{$index}}" class="checkbox checkbox-sm"
                                        [checked]="isOptionSelected('root_words', i.id)" />
                                    <label class="label" for="root_words_{{$index}}">
                                        <span class="label-text">{{i.value}} </span>
                                    </label>
                                </li>
                                }
                            </ul>
                            }

                        </div>
                    </div>
                </div>
            </li>

            <li>
                <div class="collapse collapse-plus bg-white border ">
                    <input type="checkbox" />
                    <div class="collapse-title flex items-center font-medium">Prefix</div>

                    @if ((flashcardStructureForm.get('prefix')?.get('data')?.value?.length || 0) > 0) {
                    <div class="px-3 pb-3 flex gap-2 flex-wrap">
                        @for (i of flashcardStructureForm.get('prefix')?.get('data')?.value; track $index) {
                        <button (click)="removeStructureSelection('prefix',i.id)" type="button"
                            class="btn btn-xs font-medium flex items-center gap-2"><span>{{i.value}}</span> <i
                                class="ri-close-line"></i></button>
                        }
                    </div>
                    }

                    <div class="collapse-content border-t ">
                        <div class="pt-2 max-h-[20rem] overflow-y-auto">


                            @if (structure?.prefix) {
                            <ul class="grid grid-cols-4 gap-2">
                                @for (i of structure?.prefix; track $index) {
                                <li class="flex items-center gap-2">
                                    <input (change)="updateStructureSelection($event,'prefix',i)" type="checkbox"
                                        id="prefix_{{$index}}" class="checkbox checkbox-sm"
                                        [checked]="isOptionSelected('prefix', i.id)" />
                                    <label class="label" for="prefix_{{$index}}">
                                        <span class="label-text">{{i.value}} </span>
                                    </label>
                                </li>
                                }
                            </ul>
                            }


                        </div>
                    </div>
                </div>
            </li>

            <li>
                <div class="collapse collapse-plus bg-white border">
                    <input type="checkbox" />
                    <div class="collapse-title flex items-center font-medium">Suffix</div>

                    @if ((flashcardStructureForm.get('suffix')?.get('data')?.value?.length || 0) > 0) {
                    <div class="px-3 pb-3 flex gap-2 flex-wrap">
                        @for (i of flashcardStructureForm.get('suffix')?.get('data')?.value; track $index) {
                        <button (click)="removeStructureSelection('suffix',i.id)" type="button"
                            class="btn btn-xs font-medium flex items-center gap-2"><span>{{i.value}}</span> <i
                                class="ri-close-line"></i></button>
                        }
                    </div>
                    }

                    <div class="collapse-content border-t">
                        <div class="pt-2 max-h-[20rem] overflow-y-auto">

                            @if (structure?.suffix) {
                            <ul class="grid grid-cols-4 gap-2">
                                @for (i of structure?.suffix; track $index) {
                                <li class="flex items-center gap-2">
                                    <input (change)="updateStructureSelection($event,'suffix',i)" type="checkbox"
                                        id="suffix_{{$index}}" class="checkbox checkbox-sm"
                                        [checked]="isOptionSelected('suffix', i.id)" />
                                    <label class="label" for="suffix_{{$index}}">
                                        <span class="label-text">{{i.value}} </span>
                                    </label>
                                </li>
                                }
                            </ul>
                            }

                        </div>
                    </div>
                </div>
            </li>

            <li>
                <div class="collapse collapse-plus bg-white border">
                    <input type="checkbox" />
                    <div class="collapse-title flex items-center font-medium">Theme</div>

                    @if ((flashcardStructureForm.get('theme')?.get('data')?.value?.length || 0) > 0) {
                    <div class="px-3 pb-3 flex gap-2 flex-wrap">
                        @for (i of flashcardStructureForm.get('theme')?.get('data')?.value; track $index) {
                        <button (click)="removeStructureSelection('theme',i.id)" type="button"
                            class="btn btn-xs font-medium flex items-center gap-2"><span>{{i.value}}</span> <i
                                class="ri-close-line"></i></button>
                        }
                    </div>
                    }

                    <div class="collapse-content border-t">
                        <div class="pt-2 max-h-[20rem] overflow-y-auto">

                            @if (structure?.theme) {
                            <ul class="grid grid-cols-4 gap-2">
                                @for (i of structure?.theme; track $index) {
                                <li class="flex items-center gap-2">
                                    <input (change)="updateStructureSelection($event,'theme',i)" type="checkbox"
                                        id="theme_{{$index}}" class="checkbox checkbox-sm"
                                        [checked]="isOptionSelected('theme', i.id)" />
                                    <label class="label" for="theme_{{$index}}">
                                        <span class="label-text">{{i.value}} </span>
                                    </label>
                                </li>
                                }
                            </ul>
                            }

                        </div>
                    </div>
                </div>
            </li>

            <li>
                <div class="collapse collapse-plus bg-white border">
                    <input type="checkbox" />
                    <div class="collapse-title flex items-center font-medium">Profession</div>

                    @if ((flashcardStructureForm.get('profession')?.get('data')?.value?.length || 0) > 0) {
                    <div class="px-3 pb-3 flex gap-2 flex-wrap">
                        @for (i of flashcardStructureForm.get('profession')?.get('data')?.value; track $index) {
                        <button (click)="removeStructureSelection('profession',i.id)" type="button"
                            class="btn btn-xs font-medium flex items-center gap-2"><span>{{i.value}}</span> <i
                                class="ri-close-line"></i></button>
                        }
                    </div>
                    }


                    <div class="collapse-content border-t">
                        <div class="pt-2 max-h-[20rem] overflow-y-auto">

                            @if (structure?.profession) {
                            <ul class="grid grid-cols-4 gap-2">
                                @for (i of structure?.profession; track $index) {
                                <li class="flex items-center gap-2">
                                    <input (change)="updateStructureSelection($event,'profession',i)" type="checkbox"
                                        id="profession_{{$index}}" class="checkbox checkbox-sm"
                                        [checked]="isOptionSelected('profession', i.id)" />
                                    <label class="label" for="profession_{{$index}}">
                                        <span class="label-text">{{i.value}} </span>
                                    </label>
                                </li>
                                }
                            </ul>
                            }

                        </div>
                    </div>
                </div>
            </li>

            <li>
                <div class="collapse collapse-plus bg-white border">
                    <input type="checkbox" />
                    <div class="collapse-title flex items-center font-medium">Individual Word Search</div>

                    @if ((flashcardStructureForm.get('individual_word_search')?.get('data')?.value?.length || 0) > 0) {
                    <div class="px-3 pb-3 flex gap-2 flex-wrap">
                        @for (i of flashcardStructureForm.get('individual_word_search')?.get('data')?.value; track
                        $index) {
                        <button (click)="removeStructureSelection('individual_word_search',i.id)" type="button"
                            class="btn btn-xs font-medium flex items-center gap-2"><span>{{i.value}}</span> <i
                                class="ri-close-line"></i></button>
                        }
                    </div>
                    }

                    <div class="collapse-content border-t">
                        <div class="pt-2 max-h-[20rem] overflow-y-auto">

                            @if (structure?.individual_word_search) {
                            <ul class="grid grid-cols-4 gap-2">
                                @for (i of structure?.individual_word_search; track $index) {
                                <li class="flex items-center gap-2">
                                    <input (change)="updateStructureSelection($event,'individual_word_search',i)"
                                        type="checkbox" id="individual_word_search_{{$index}}"
                                        class="checkbox checkbox-sm"
                                        [checked]="isOptionSelected('individual_word_search', i.id)" />
                                    <label class="label" for="individual_word_search_{{$index}}">
                                        <span class="label-text">{{i.value}} </span>
                                    </label>
                                </li>
                                }
                            </ul>
                            }

                        </div>
                    </div>
                </div>
            </li>

        </ul>



        <div class="flex justify-end mt-5">
            <button type="submit" class="btn btn-sm capitalize btn-primary" [disabled]="isReqSent">
                @if (isReqSent) {
                <i class="ri-loader-2-line animate-spin"></i>
                }@else {
                <span>Save</span>
                }
            </button>
        </div>

    </form>

</div>